import React from "react";

import TaxRatesPage from "../TaxRates/TaxRatesPage";
import { TAX_RATES_COUNTY_CONFIG } from "../TaxRates/configs";

// Tributos Municipais (PO1-2730): wrapper fino da página compartilhada de Tributos.
const TaxRatesCounty = () => <TaxRatesPage {...TAX_RATES_COUNTY_CONFIG} />;

export default TaxRatesCounty;
